export default class PecaInput {
    constructor (nomePeca) {
        this.name = nomePeca
    }

    static create(nomePeca) {
        return new PecaInput(nomePeca)
    }

}